import React, { ReactNode, useState } from "react";
import Tab from "../../../generic/tab";
import NavigationDropdown from "../../../generic/navigationDropdown";
import secNavOptions, { scrlStCls, newOfferOptions } from "../obConstants";
import { ObScrollService } from "../../../service/orderBook/obScrollService";
import NavigationTag from "../../../generic/navigationTag";
import { useParams } from "react-router-dom";
import "../../../../assets/scss/components/generic/layout/layoutTab.scss";
import "../../../../assets/scss/components/toc/orderBook/obContainer/obContainerTab.scss";
import { IListObj } from "../../../types/genericTypes";

export interface IObContainerTabProps {
	priNavOptions?: Array<IListObj>;

	instComp?: ReactNode;
	isPriNavHidden?: boolean;
	// primary market related props
	handleInstNav?: (value: any) => void;
}

const ObContainerTab: React.FC<IObContainerTabProps> = (props: IObContainerTabProps) => {
	const [isFixed, setIsFixed] = useState<boolean>(false);

	const { secNav, pageNav, inst } = useParams<{ secNav: string; pageNav: string; inst: string }>(); //section navigation,page navigation, primary market instrument

	function onContainerScroll(e: React.UIEvent<HTMLElement>) {
		// console.dir((e.target as HTMLElement).scrollTop);
		// if scrolltop is greater than 78 then fix the header
		(e.target as HTMLElement).scrollTop > (inst ? 88 : 48) ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);
		setTimeout(() => {
			ObScrollService(isFixed);
		});
	}
	return (
		<section
			className={"outer_container container_tab  " + (props.isPriNavHidden ? " selectActive" : "") + (isFixed ? " obScrollActive" : "")}
			onScroll={onContainerScroll}
			id={scrlStCls.pContId}
		>
			<section className="ob_container lyCont tab">
				<section className="ob_listing_tab ly_listing_tab">
					<div className="ob_tbl_header">
						<div className={"list_title_tab"}>
							{props.priNavOptions && (
								<NavigationDropdown
									type="page_nav"
									defaultValue={pageNav || "today"}
									dropdownOptions={props.priNavOptions}
									onSelect={() => {}}
								/>
							)}
						</div>

						<div className={"list_info_tab"}>
							<Tab defaultValue={secNav || "equity"} tabList={secNavOptions()} position="center" />
						</div>
						{/* new offers navigation */}
						{inst && (
							<div className="taCenter mg-t25 ">
								<NavigationTag
									defaultValue={inst || "today"}
									tagList={newOfferOptions}
									onSelect={props.handleInstNav ? props.handleInstNav : () => {}}
								/>
							</div>
						)}
					</div>
					<div className={"list_details_tab obTableData"}>{props.instComp}</div>
				</section>
			</section>
		</section>
	);
};

export default ObContainerTab;
